/**
 * H5 页面通用登录 mixin
 *
 * 用法：在页面组件中引入 mixins: [h5LoginMixin]
 * 页面需提供 onLoginSuccess() 方法，登录成功后调用
 *
 * 登录时保存 IS_SUBSIDIARY_LEADER 标识到 sessionStorage
 * （通过 enterpriseInfoList.principalId 对比 username 判断）
 */
export default {
  created() {
    if (sessionStorage.getItem('WXID')) {
      this.onLoginSuccess && this.onLoginSuccess();
      return;
    }
    const code = this.$route.query.code;
    if (!code) {
      return;
    }
    this.doLogin(code);
  },
  methods: {
    async doLogin(code) {
      try {
        const res = await this.$api.login({ emAuthCode: code });
        if (res.code === 200) {
          this._saveLoginInfo(res.result);
          this.onLoginSuccess && this.onLoginSuccess();
        } else if (sessionStorage.getItem('TOKEN')) {
          // 有历史 token，跳过
          this.onLoginSuccess && this.onLoginSuccess();
        } else {
          this.$router.replace({ path: '/403', query: { reason: res.message } });
        }
      } catch (e) {
        if (sessionStorage.getItem('TOKEN')) {
          this.onLoginSuccess && this.onLoginSuccess();
        }
      }
    },
    _saveLoginInfo(data) {
      sessionStorage.setItem('WXID', data.wxId);
      sessionStorage.setItem('TOKEN', data.loginToken);
      sessionStorage.setItem('UID', data.userId);
      sessionStorage.setItem('UNAME', data.username);
      sessionStorage.setItem('ROLEID', data.roleId);
      sessionStorage.setItem('ROLENAME', data.roleName);
      sessionStorage.setItem('NICKNAME', data.nickName);
      sessionStorage.setItem('MOBILE', data.mobile);
      sessionStorage.setItem('PLATFORMCODE', data.platformCode);
      sessionStorage.setItem('PLATFORMNAME', data.platformName);
      sessionStorage.setItem('MENULIST', JSON.stringify(data.menuList));
      // 判断是否子公司负责人
      const isLeader = (data.enterpriseInfoList || []).some(
        e => e.principalId === data.username
      );
      sessionStorage.setItem('IS_SUBSIDIARY_LEADER', isLeader ? 'true' : 'false');
      this.$store.commit('SET_TOKEN', data.loginToken);
      this.$store.dispatch('set_name', data.username);
    },
  },
};
